<template>
  <div class="review-order-condition-setting" v-loading="isLoading">
    <div class="title">传单前必须满足审单条件后才能传单</div>
    <div class="setting-item">
      <div>
        <span
          >可按需配置审单条件，当订单满足指定审单条件时自动生成审单任务，支持设置是否审核通过才能传单。说明：传单权限与MTDS传单权限保持一致。</span
        >
        <el-switch
          v-model="reviewOrderCondition.status"
          active-text="是"
          inactive-text="否"
          :active-value="0"
          :inactive-value="1"
          @change="changeReviewOrderConditionStatus"
        >
        </el-switch>
        <el-button
          size="small"
          type="primary"
          @click="handleExport"
          style="margin-left: 15px"
        >
          导出
        </el-button>
        <el-upload
          ref="uploadRef"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleFileChange"
          accept=".xlsx,.xls"
          style="margin-left: 10px; display: inline-block"
          action="#"
        >
          <el-button size="small" type="primary"> 导入 </el-button>
        </el-upload>
      </div>
      <div
        class="review-order-condition-table"
        v-if="!reviewOrderCondition.status"
      >
        <el-table
          :data="reviewOrderCondition.conditionList"
          border
          style="width: 100%"
          size="mini"
        >
          <el-table-column align="center" min-width="125">
            <template #header>
              <span>条件</span>
              <el-button
                size="small"
                type="text"
                @click="addReviewOrderCondition"
                >添加条件</el-button
              >
            </template>
            <template v-slot="{ $index, row }">
              <span>条件{{ $index + 1 }}</span>
              <div>
                <el-checkbox
                  v-model="row.isAuditRequiredForTransmit"
                  :true-label="1"
                  :false-label="0"
                >
                  审核通过才能传单
                </el-checkbox>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" min-width="200">
            <template #header>
              <span>审单界面条件说明文本</span>
              <el-tooltip
                content="配置需要在审单任务中展示的审单说明，如“新设计师订单需要审核”、“遗留单需要审核”等"
                placement="top"
              >
                <i class="el-icon-warning" style="cursor: pointer"></i>
              </el-tooltip>
            </template>
            <template v-slot="{ row }">
              <el-input
                v-model="row.explanationText"
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 10 }"
                size="small"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" min-width="400">
            <template #header>
              <span>审单要求(需符合该条件的所有要求)</span>
              <el-tooltip
                content="同一级审核人若配置多个则任意一个审核即可，所有环节审核人审核顺序不分先后
"
                placement="top"
              >
                <i class="el-icon-warning" style="cursor: pointer"></i>
              </el-tooltip>
            </template>
            <template v-slot="{ row }">
              <div class="review-order-requirement">
                <div>
                  <span>组织架构/指定人员要求：</span>
                  <el-tooltip
                    placement="top"
                    :content="`部门：${getListLabelByKey(row, 'departmentList')}`"
                  >
                    <div
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'setting')"
                    >
                      部门：{{ getListLabelByKey(row, "departmentList") }}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    :content="`人员：${getListLabelByKey(row, 'personList')}`"
                  >
                    <div
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'setting')"
                    >
                      人员：{{ getListLabelByKey(row, "personList") }}
                    </div>
                  </el-tooltip>
                  <el-button
                    size="small"
                    type="text"
                    @click="handleSetting(row, 'setting')"
                    >设置</el-button
                  >
                </div>

                <div>
                  <span>人员入职时间要求：</span>
                  <el-select
                    v-model="row.personEntryTime"
                    size="mini"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="item in personEntryTimeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <span :style="{ opacity: 0 }">占位</span>
                </div>

                <div>
                  <span>订单属性要求：</span>
                  <el-tooltip
                    placement="top"
                    :content="getOrderConditionStatus(row)"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'orderCondition')"
                    >
                      {{ getOrderConditionStatus(row) }}
                    </span>
                  </el-tooltip>
                  <el-button
                    size="small"
                    type="text"
                    @click="handleSetting(row, 'orderCondition')"
                    >设置</el-button
                  >
                </div>

                <div>
                  <span>设计指标要求：</span>
                  <el-tooltip
                    placement="top"
                    content="业务需求收集中，欢迎反馈！"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-disabled"
                    >
                      业务需求收集中，欢迎反馈！
                    </span>
                  </el-tooltip>
                  <el-button size="small" type="text" :disabled="true"
                    >设置</el-button
                  >
                </div>

                <div>
                  <span>财务指标要求：</span>
                  <el-tooltip
                    placement="top"
                    content="业务需求收集中，欢迎反馈！"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-disabled"
                    >
                      业务需求收集中，欢迎反馈！
                    </span>
                  </el-tooltip>
                  <el-button size="small" type="text" :disabled="true"
                    >设置</el-button
                  >
                </div>

                <div>
                  <span> 第一环节审核人： </span>
                  <el-tooltip
                    placement="top"
                    :content="getListLabelByKey(row, 'firstStageReviewerList')"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'firstStageReviewerList')"
                    >
                      {{ getListLabelByKey(row, "firstStageReviewerList") }}
                    </span>
                  </el-tooltip>
                  <el-button
                    size="small"
                    type="text"
                    @click="handleSetting(row, 'firstStageReviewerList')"
                    >设置</el-button
                  >
                </div>
                <div>
                  <span> 第二环节审核人： </span>
                  <el-tooltip
                    placement="top"
                    :content="getListLabelByKey(row, 'secondStageReviewerList')"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'secondStageReviewerList')"
                    >
                      {{ getListLabelByKey(row, "secondStageReviewerList") }}
                    </span>
                  </el-tooltip>
                  <el-button
                    size="small"
                    type="text"
                    @click="handleSetting(row, 'secondStageReviewerList')"
                    >设置</el-button
                  >
                </div>
                <div>
                  <span> 第三环节审核人： </span>
                  <el-tooltip
                    placement="top"
                    :content="getListLabelByKey(row, 'thirdStageReviewerList')"
                  >
                    <span
                      class="reviewer-label-ellipsis reviewer-value-clickable"
                      @click="handleSetting(row, 'thirdStageReviewerList')"
                    >
                      {{ getListLabelByKey(row, "thirdStageReviewerList") }}
                    </span>
                  </el-tooltip>
                  <el-button
                    size="small"
                    type="text"
                    @click="handleSetting(row, 'thirdStageReviewerList')"
                    >设置</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" min-width="125" label="操作">
            <template v-slot="{ row }">
              <el-button
                size="small"
                type="text"
                @click="copyReviewOrderCondition(row)"
              >
                复制
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="deleteReviewOrderCondition(row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <OrderConditionDialog
      v-if="orderConditionListDialogVisible"
      :visible.sync="orderConditionListDialogVisible"
      :value="currentOrderConditionRow.orderConditionList"
      @confirm="handleOrderConditionConfirm"
    />
  </div>
</template>

<script>
import {
  queryReviewConditionList,
  saveOrUpdateReviewConditionList,
} from "@/api/reviewOrder/index.js";
import { importReviewCondition } from "@/api/designordercenter/designUnifiedRuleController/importReviewCondition/post.js";
import { exportReviewConditionList } from "@/api/designordercenter/designUnifiedRuleController/exportReviewConditionList/get.js";
import {
  reqGetCurrentUser,
  downloadByData,
  getFilenameByResponseHeaders,
} from "@oppein/op-utils";
import { getOauth2AccessToken } from "@/api/factory.js";
import OrderConditionDialog from "./OrderConditionDialog.vue";

const TOKEN_KEY = "Oauth2-AccessToken";

export default {
  name: "ReviewOrderConditionSetting",
  components: { OrderConditionDialog },
  data() {
    return {
      isLoading: false, // 控制加载状态
      // 审单条件数据
      reviewOrderCondition: {},
      // 人员入职时间选项
      personEntryTimeOptions: [
        { label: "一个月内", value: 1 },
        { label: "三个月内", value: 3 },
        { label: "六个月内", value: 6 },
        { label: "十二个月内", value: 12 },
      ],
      orderConditionListDialogVisible: false,
      currentOrderConditionRow: null,
    };
  },
  computed: {
    // 用户选择的iframe URL
    userSelectedIframeUrl() {
      const accessToken = getOauth2AccessToken();
      return `${process.env.DESIGN_QUOTATION_PATH}/activity/userSelection?${TOKEN_KEY}=${accessToken}`;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getReviewConditionList();
    },
    /**
     * 校验审核人配置
     * @param conditionList
     * @returns {string|null} 返回错误信息，无错误返回null
     */
    validate() {
      // 关闭的时候，校验直接通过
      if (this.reviewOrderCondition.status) return true;
      const validateReviewers = (conditionList) => {
        if (!Array.isArray(conditionList)) return null;

        for (let i = 0; i < conditionList.length; i++) {
          const condition = conditionList[i];
          const explanationText = condition.explanationText || `条件${i + 1}`;

          // 检查是否至少配置了一级审核人
          const hasFirstStageReviewer =
            Array.isArray(condition.firstStageReviewerList) &&
            condition.firstStageReviewerList.length > 0;

          if (!hasFirstStageReviewer) {
            return `${explanationText}未配置审核人，请设置`;
          }
        }

        return null;
      };

      const validationError = validateReviewers(
        this.reviewOrderCondition.conditionList,
      );
      if (validationError) {
        this.$message.error(validationError);
        return false;
      } else {
        return true;
      }
    },
    /**
     * 保存数据 - 供父组件调用
     */
    async saveData() {
      try {
        if (!this.reviewOrderCondition.conditionList) return;
        this.isLoading = true;
        const currentUser = await reqGetCurrentUser();
        const conditionList = JSON.parse(
          JSON.stringify(this.reviewOrderCondition.conditionList),
        );

        // 校验审核人配置
        const validationStatus = this.validate(conditionList);
        if (!validationStatus) {
          return;
        }

        conditionList.forEach((condition) => {
          if (Array.isArray(condition.orderConditionList)) {
            condition.orderConditionList.forEach((item) => {
              if (item.value === null || item.value === undefined) {
                item.value = "";
              } else if (typeof item.value === "object") {
                // 如果是对象，转换为JSON字符串
                item.value = JSON.stringify(item.value);
              }
            });
          }
        });

        const res = await saveOrUpdateReviewConditionList({
          ...this.reviewOrderCondition,
          deparment: currentUser.orgNo, // 设置所属商场
          conditionList,
        });
        if (!res.status) {
          throw new Error(res.message || "保存失败");
        }
        return res;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 获取审单条件列表数据
     */
    async getReviewConditionList() {
      try {
        this.isLoading = true;
        const currentUser = await reqGetCurrentUser();
        const response = await queryReviewConditionList({
          orgNo: currentUser.orgNo,
        });
        const data = response.data || {};
        if (Array.isArray(data.conditionList)) {
          data.conditionList.forEach((condition) => {
            if (Array.isArray(condition.orderConditionList)) {
              const physicalShopItem = condition.orderConditionList.find((item) => item.code === "physicalShopId");
              if (!physicalShopItem) {
                condition.orderConditionList.unshift({
                  name: "所属门店",
                  code: "physicalShopId",
                  verification: false,
                  value: null,
                });
              }
              condition.orderConditionList.forEach((item) => {
                if (typeof item.value === "string" && item.value) {
                  try {
                    item.value = JSON.parse(item.value);
                  } catch (e) {
                    console.error(e);
                  }
                }
              });
            } else {
              condition.orderConditionList =
                this.getDefaultOrderConditionList();
            }
          });
        }
        this.reviewOrderCondition = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 刷新数据
     */
    async refreshData() {
      await this.getReviewConditionList();
    },
    /**
     * 获取默认的订单属性要求列表
     */
    getDefaultOrderConditionList() {
      return [
         {
          name: "所属门店",
          code: "physicalShopId",
          verification: false,
          value: null,
        },
        {
          name: "品牌品类",
          code: "brandCategory",
          verification: false,
          value: null,
        },
        {
          name: "产品渠道",
          code: "productChannel",
          verification: false,
          value: null,
        },
        {
          name: "是否遗留单",
          code: "leaveOrder",
          verification: false,
          value: null,
        },
        {
          name: "是否补单",
          code: "repeatOrder",
          verification: false,
          value: null,
        },
        {
          name: "产品类别",
          code: "productType",
          verification: false,
          value: null,
        },
        {
          name: "订单类型",
          code: "orderType",
          verification: false,
          value: null,
        },
        {
          name: "设计来源",
          code: "designSource",
          verification: false,
          value: null,
        },
        {
          name: "客户期望交期",
          code: "customerExpectDeliveryTime",
          verification: false,
          value: null,
        },
      ];
    },
    /**
     * 添加审单条件
     */
    addReviewOrderCondition() {
      const newCondition = {
        explanationText: "",
        departmentList: [],
        personList: [],
        personEntryTime: undefined,
        orderConditionList: this.getDefaultOrderConditionList(),
        firstStageReviewerList: [],
        secondStageReviewerList: [],
        thirdStageReviewerList: [],
        isAuditRequiredForTransmit: 1,
      };
      if (Array.isArray(this.reviewOrderCondition.conditionList)) {
        this.reviewOrderCondition.conditionList.push(newCondition);
      } else {
        this.reviewOrderCondition.conditionList = [newCondition];
      }
    },
    handleSetting(row, type) {
      switch (type) {
        case "orderCondition": {
          this.currentOrderConditionRow = row;
          this.orderConditionListDialogVisible = true;
          return;
        }
        case "setting": {
          const iframe = document.createElement("iframe");
          iframe.src = this.userSelectedIframeUrl;
          iframe.style.cssText = `
                                  position: fixed;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                  border: none;
                                  z-index: 9999;
                                `;
          // 监听消息
          const handleMessage = (event) => {
            const { type, data } = event.data || {};

            if (type === "USER_SELECTION_READY") {
              iframe.contentWindow.postMessage(
                {
                  type: "OPEN_USER_SELECTION",
                  params: {
                    selectedUser: row.personList
                      ? row.personList.map((item) => ({
                          userId: item.id,
                          userName: item.name,
                        }))
                      : [],
                    selectedOrg: row.departmentList
                      ? row.departmentList.map((item) => ({
                          orgId: item.id,
                          orgName: item.name,
                        }))
                      : [],
                    orgSelectable: true,
                  },
                },
                "*",
              );
            } else if (type === "USER_SELECTED") {
              console.log("Received message from iframe:---------", event.data);
              if (data) {
                row.personList = data.selectedUser
                  ? data.selectedUser.map((item) => ({
                      id: item.userId,
                      name: item.userName,
                    }))
                  : [];
                row.departmentList = data.selectedOrg
                  ? data.selectedOrg.map((item) => ({
                      id: item.orgId,
                      name: item.orgName,
                    }))
                  : [];
              }
              // 关闭 iframe
              document.body.removeChild(iframe);

              window.removeEventListener("message", handleMessage);
            }
          };

          window.addEventListener("message", handleMessage);

          // 添加到页面
          document.body.appendChild(iframe);
          break;
        }
        case "firstStageReviewerList":
        case "secondStageReviewerList":
        case "thirdStageReviewerList": {
          // 选人iframe，选完后写入对应 reviewerList
          const iframe = document.createElement("iframe");
          iframe.src = this.userSelectedIframeUrl;
          iframe.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
            z-index: 9999;
          `;
          const handleMessage = (event) => {
            const { type: msgType, data } = event.data || {};
            if (msgType === "USER_SELECTION_READY") {
              iframe.contentWindow.postMessage(
                {
                  type: "OPEN_USER_SELECTION",
                  params: {
                    selectedUser: row[`${type}`]
                      ? row[`${type}`].map((item) => ({
                          userId: item.id,
                          userName: item.name,
                        }))
                      : [],
                    orgSelectable: false,
                  },
                },
                "*",
              );
            } else if (msgType === "USER_SELECTED") {
              if (data) {
                row[`${type}`] = data.selectedUser
                  ? data.selectedUser.map((item) => ({
                      id: item.userId,
                      name: item.userName,
                    }))
                  : [];
              }
              document.body.removeChild(iframe);
              window.removeEventListener("message", handleMessage);
            }
          };
          window.addEventListener("message", handleMessage);
          document.body.appendChild(iframe);
          break;
        }
        default:
          break;
      }
    },
    /**
     * 处理订单条件确认
     * @param list
     */
    handleOrderConditionConfirm(list) {
      this.currentOrderConditionRow.orderConditionList = list;
    },
    /**
     * 删除审单条件
     */
    deleteReviewOrderCondition(row) {
      if (
        !this.reviewOrderCondition ||
        !Array.isArray(this.reviewOrderCondition.conditionList)
      )
        return;
      const idx = this.reviewOrderCondition.conditionList.indexOf(row);
      if (idx > -1) {
        this.reviewOrderCondition.conditionList.splice(idx, 1);
      }
    },
    /**
     * 复制审单条件
     */
    copyReviewOrderCondition(row) {
      if (
        !this.reviewOrderCondition ||
        !Array.isArray(this.reviewOrderCondition.conditionList)
      )
        return;
      // 深拷贝row
      const copy = JSON.parse(JSON.stringify(row));
      this.reviewOrderCondition.conditionList.push(copy);
    },
    /**
     * 通过key获取列表标签
     * @param row
     * @param key
     */
    getListLabelByKey(row, key) {
      if (Array.isArray(row[key]) && row[key].length > 0) {
        return row[key].map((item) => item.name).join(", ");
      }
      return "";
    },
    /**
     * 获取订单条件状态显示文本
     * @param row
     */
    getOrderConditionStatus(row) {
      if (
        !Array.isArray(row.orderConditionList) ||
        row.orderConditionList.length === 0
      ) {
        return "暂无设置";
      }

      const setConditions = row.orderConditionList.filter(
        (item) => item.verification === true,
      );

      if (setConditions.length === 0) {
        return "暂无设置";
      }

      const conditionNames = setConditions.map((item) => item.name);
      return `已设置属性：${conditionNames.join(", ")}`;
    },
    /**
     * 切换审单条件状态
     * @param status
     */
    changeReviewOrderConditionStatus(status) {
      if (status) return;
      // 如果启用审单条件，列表为空，默认添加一条条件
      if (
        !this.reviewOrderCondition.conditionList ||
        this.reviewOrderCondition.conditionList.length === 0
      ) {
        this.addReviewOrderCondition();
      }
    },
    /**
     * 导出审单条件
     */
    async handleExport() {
      try {
        this.isLoading = true;
        const currentUser = await reqGetCurrentUser();

        const response = await exportReviewConditionList({
          orgNo: currentUser.orgNo,
        });

        const filenameFromHeader = getFilenameByResponseHeaders(
          response.headers,
        );

        const filename = filenameFromHeader;
        await downloadByData(response.data, filename);

        this.$message.success("导出成功");
      } catch (error) {
        console.error(error);
        this.$message.error(error.message || "导出失败");
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 处理文件选择
     */
    async handleFileChange(file, fileList) {
      if (!file || !file.raw) return;

      try {
        this.isLoading = true;

        const formData = new FormData();
        formData.append("file", file.raw);

        const response = await importReviewCondition(formData);

        if (!response.status) {
          this.$message.error(response.message);
          return;
        }
        // 导入成功后刷新数据
        await this.refreshData();
        this.$message.success(response.message);
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        // 清空上传组件的文件列表
        this.$refs.uploadRef.clearFiles();
      }
    },
  },
};
</script>
<style lang="scss">
.review-order-condition-setting {
  .review-order-condition-table {
    .el-table th {
      background-color: #dceaff;
      color: #3f3f3f;
    }
  }
}
</style>

<style scoped lang="scss">
.review-order-condition-setting {
  > .title {
    color: var(--color-primary);
    font-size: 16px;
    font-weight: bold;
    border-left: 4px solid var(--color-primary);
    padding-left: 5px;
  }
  > .setting-item {
    background-color: #f1f1f1;
    padding: 10px;
    line-height: 2.5em;
    margin: 10px 0;
    .review-order-condition-table {
      margin-top: 10px;
      .review-order-requirement {
        > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          > span:first-child {
            // font-weight: bold;
            margin-right: 10px;
            white-space: nowrap;
          }
          > .el-button:last-child {
            margin-left: 10px;
          }
        }
        .reviewer-label-ellipsis {
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
        }
        .reviewer-value-clickable {
          color: #409eff;
          cursor: pointer;
          transition: color 0.3s;
          &:hover {
            color: #66b1ff;
          }
        }
        .reviewer-value-disabled {
          color: #c0c4cc;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// reviewOrderCondition.vue?5078cad6